import { DatabaseView } from '@databases/types/database/view';
import { isUniqueViewName } from '@databases/views/utils/viewName';
import React, { FunctionComponent, useEffect } from 'react';
import styled from 'styled-components';

interface ViewNameContainerProps {
  isActive?: boolean;
  isDefault: boolean;
}

const getMaxWidth = (isViewActionsOpen: boolean, isDefault: boolean) => {
  if (isViewActionsOpen) {
    return isDefault ? '190px' : '240px';
  } else {
    return isDefault ? '240px' : '300px';
  }
};

export const ViewNameContainer = styled.div<ViewNameContainerProps>`
  min-height: 20px;
  padding: 2px 1px;
  border-radius: 2px;
  max-width: ${(props) =>
    getMaxWidth(props.isViewActionsOpen, props.isDefault)} !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export interface ViewCardNameEditProps {
  name: string;
  existingViewNames?: string[];
  view: DatabaseView;
  setDuplicateViewNameErrorId: (value: string) => void;
  validationProps: any;
  isActive?: boolean;
  isDefault: boolean;
  isViewActionsOpen: boolean;
}

const ViewCardNameEdit: FunctionComponent<ViewCardNameEditProps> = ({
  name,
  existingViewNames = [],
  view,
  setDuplicateViewNameErrorId,
  isActive = false,
  isDefault,
  isViewActionsOpen,
}) => {
  useEffect(() => {
    if (existingViewNames && !isUniqueViewName(view.name, existingViewNames)) {
      setDuplicateViewNameErrorId(view.id);
    } else {
      setDuplicateViewNameErrorId('');
    }
  }, [existingViewNames, setDuplicateViewNameErrorId, view.id, view.name]);

  return (
    <ViewNameContainer
      data-testid="view-name-container"
      isDefault={isDefault}
      isActive={isActive}
      isViewActionsOpen={isViewActionsOpen}
    >
      {name}
    </ViewNameContainer>
  );
};

export default ViewCardNameEdit;
